import React from "react";
import ComponenteSimpleForm from "./ComponenteSimpleForm";

export default function UnidadCondensadoraForm() {
  return (
    <ComponenteSimpleForm
      titulo="Unidad Condensadora"
      tipo="unidadCondensadora"
    />
  );
}
